"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var graphql_tag_1 = require("graphql-tag");
exports.userQuery = graphql_tag_1.default("query user {\n  user {\n    isAdmin\n    checklists {\n      id\n      parentId\n      title\n      description\n      weight\n      icon {\n        id\n        imageUrl\n      }\n      days\n      notifyAt\n      weight\n      createdAt\n      endsAt\n    }\n  }\n}");
